/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bank_medium'
export default icon
